import Vue from 'vue';
import Vuex from 'vuex';
import index from './screens/Index/store';
import modal from './shared/components/modal/store';
import search from './screens/Search/store';
import faq from './screens/Faq/store';
import classContent from './screens/Class/Content/store';
import classDetails from './screens/Class/Details/store';
import classSidebar from './screens/Class/ClassSidebar/store';
import classHeader from './screens/Class/Header/store';
import classIndex from './screens/Class/Index/store';
import classProgress from './screens/Class/Progress/store';
import classComments from './screens/Class/Details/Comments/store';
import classDescription from './screens/Class/Details/Description/store';
import classDownloads from './screens/Class/Details/Downloads/store';
import classNotes from './screens/Class/Details/Notes/store';
import profile from './screens/Profile/store';
import banner from './shared/components/banner/store';
import app from './screens/App/store';
import community from './screens/Community/store';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'staging';

export default new Vuex.Store({
  modules: {
    index,
    modal,
    search,
    faq,
    classContent,
    classDetails,
    classHeader,
    classIndex,
    classProgress,
    classComments,
    classDescription,
    classSidebar,
    classDownloads,
    classNotes,
    profile,
    banner,
    app,
    community,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store.js